import { c as _c } from "react/compiler-runtime";
import { CONTACT_API } from 'modules/contacts/api/contact-api';
import { ContactCampaignsApiInterface } from 'modules/contacts/contact-page/types/contact-campaigns-interface';
import { RequestModuleEnum } from 'shared/enums/request-module-enum';
import { useControlledSwr } from 'shared/hooks/use-controlled-swr';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import useUser from 'shared/hooks/use-user';
import { SwrPaginationInterface } from 'shared/types/pagination-interface';
import { getPaginationQueryString } from 'shared/utils/api/get-pagination-query-string';
import { ContactId } from '../../types/contact-interface';
interface UseContactCampaignsInterface extends SwrPaginationInterface {
  contactId: ContactId;
}
export function useContactCampaigns(t0) {
  const $ = _c(8);
  const {
    limit,
    pagination,
    contactId
  } = t0;
  const {
    user
  } = useUser();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      method: RequestMethodsEnum.get
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    fetcher
  } = useFetch(t1);
  let t2;
  if ($[1] !== contactId || $[2] !== limit || $[3] !== pagination) {
    t2 = () => [`${CONTACT_API}/contacts/${contactId}/campaigns?${getPaginationQueryString({
      limit,
      pagination
    })}`, RequestModuleEnum.Campaign, RequestModuleEnum.CampaignStep];
    $[1] = contactId;
    $[2] = limit;
    $[3] = pagination;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const {
    data: contactCampaigns,
    mutate
  } = useControlledSwr(t2, fetcher, undefined, !!user);
  let t3;
  if ($[5] !== contactCampaigns || $[6] !== mutate) {
    t3 = {
      contactCampaigns,
      mutate
    };
    $[5] = contactCampaigns;
    $[6] = mutate;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
}